export const dictionary = {
  base: {
    typeId: 'Тип',
    topic: 'Тема',
    description: 'Опис',
    attachment: 'Вкладені файли',
    authorId: 'Автор',
    executorId: 'Виконавець',
    deadline: 'Термін виконання',
    contractor: 'Контрагент',
    subject: 'Тема',
    related_correspondences: "Пов'язана кореспонденція",
    isOrigin: 'Оригінал документів',
    documentTypeId: 'Тип документа',
    documentPriorityTypeId: 'Пріоритет',
    documentDeliveryTypeId: 'Тип доставлення/Тип відправлення',
    deliveryCost: 'Ціна доставки',
    ttn: 'ТТН (Товарно-транспортна накладна)',
    registrationNumber: 'Номер',
    registrationDate: 'Дата реєстрації',
    departmentId: 'Департамент',
    roleId: 'Роль',
    addressId: 'Адреса',
    documents: 'Документи',
    document: 'Документ',
    isSecretFinancial: 'Таємниця фінансових послуг',
    number: 'Номер',
    date: 'Дата',
    directionId: 'Напрямок',
    isActive: 'Активний',
    fromDate: 'Дата від',
    toDate: 'Дата до',
    startDate: 'Дата початку',
    endDate: 'Дата закінчення',
    period: 'Період',
    issuedUserId: 'Відповідальний',
    responsibleId: 'Відповідальний',
    statusId: 'Статус',
    year: 'Рік',
    startScheduledCheckDate: 'Планова дата початку',
    endScheduledCheckDate: 'Планова дата закінчення',
    executors: 'Виконавець',
    executor: 'Виконавець',
    comment: 'Коментар',
    created_at: 'Дата створення',
    updated_at: 'Дата оновлення',
    docTypeDefinitionId: 'Вид документа',
    docTypeClassId: 'Клас документа',
    registrationJournalId: 'Журнал реєстрації',
  },
  document: {
    typeId: 'Тип документа',
  },
  documentStatus: {
    draft: 'Чернетка',
    active: 'Активний',
    archived: 'Архів',
    in_progress: 'В роботі',
    revision: 'Доопрацювання',
    on_registration: 'На реєстрації',
    registered: 'Зареєстровано',
    registration_cancelled: 'Відміна реєстрації',
    under_review: 'На розгляді',
    in_execution: 'На виконанні',
  },
  correspondence: {
    typeId: 'Тип кореспонденції',
    contractorId: 'Кореспондент',
    registrationDate: 'Дата реєстрації',
  },
  internalStaffUnit: {
    name: 'Повна назва штатної одиниці',
    departmentId: 'Підрозділ',
    positionId: 'Посада',
    staffUnitTypeId: 'Тип штатної одиниці',
  },
  staffUnitAssignment: {
    employeeId: 'Співробітник',
    appointmentTypeId: 'Тип призначення',
    dateFrom: 'Дата початку',
  },
  internalDepartment: {
    name: 'Назва підрозділу',
    internalCode: 'Внутрішній код',
    departmentTypeId: 'Тип підрозділу',
  },
  orgDirectoryItem: {
    name: 'Назва',
  },
  task: {
    completedDate: 'Дата виконання',
    completedStartDate: 'Початок виконання',
    completedEndDate: 'Закінчення виконання',
    deadlineStartDate: 'Термін виконання від',
    deadlineEndDate: 'Термін виконання до',
    text: 'Звіт про виконання завдання',
  },
  incident: {
    name: 'Назва',
    typeId: 'Тип',
    categoryId: 'Категорія',
    statusId: 'Статус',
    priorityId: 'Пріоритет',
    initiatorId: 'Відповідальний',
    occurredDate: 'Дата виникнення',
    occurredDateStart: 'Дата виникнення від',
    occurredDateEnd: 'Дата виникнення до',
    detectedDate: 'Дата виявлення',
    detectedDateStart: 'Дата виявлення від',
    detectedDateEnd: 'Дата виявлення до',
    resolvedDate: 'Дата врегулювання',
    resolvedDateStart: 'Дата врегулювання від',
    resolvedDateEnd: 'Дата врегулювання до',
  },
  incidentCreate: {
    name: 'Назва',
    typeId: 'Тип інциденту',
    priorityId: 'Пріоритет',
  },
  docTypeClass: {
    name: 'Назва',
  },
  fieldDefinition: {
    name: 'Назва',
    fieldType: 'Тип поля',
  },
  registrationJournal: {
    name: 'Назва журналу',
    code: 'Код',
  },
  maskPlaceholder: {
    maskName: 'Назва',
    numberMask: 'Код',
  },
  user: {
    name: "Ім'я",
    surname: 'Прізвище',
    patronymic: 'По батькові',
    genderId: 'Стать',
    birthDate: 'Дата народження',
    inn: 'ІПН',
    photo: 'Фото',
    phone: 'Телефон',
    email: 'Пошта',
    profileDWH: 'profileDWH',
  },
  incidentRiskAssessment: {
    damageCost: 'Сума збитків',
    damageCostBased: 'Базовий показник',
    damageCostPotential: 'Можливі втрати',
    probabilityLevelId: 'Ймовірність реалізації',
  },
  incidentExecutor: {
    executorId: 'Виконавець',
  },
} as const
